const getIndicadorQualidadeRespFilterFields = (drops = {}, indicadorId) => [
  {
    name: 'qualidade_indicador_id',
    label: 'Indicador de Qualidade',
    type: 'select',
    options: drops?.QualidadeIndicador,
    multiple: true,
    defaultValue: indicadorId ? [indicadorId] : [],
    show: false,
  },
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'sequencia',
    label: 'Sequência',
    type: 'number',
  },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'peso',
    label: 'Peso',
    type: 'number',
  },
  {
    name: 'minimo',
    label: 'Mínimo',
    type: 'number',
  },
  {
    name: 'maximo',
    label: 'Máximo',
    type: 'number',
  },
  {
    name: 'inivalid.i',
    column: 'inivalid',
    label: 'Início da Validade Inicial',
    type: 'date',
  },
  {
    name: 'inivalid.f',
    column: 'inivalid',
    label: 'Início da Validade Final',
    type: 'date',
  },
  {
    name: 'fimvalid.i',
    column: 'fimvalid',
    label: 'Fim da Validade Inicial',
    type: 'date',
  },
  {
    name: 'fimvalid.f',
    column: 'fimvalid',
    label: 'Fim da Validade Final',
    type: 'date',
  },
];

export default getIndicadorQualidadeRespFilterFields;
